<style >

.mainApp {
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: hidden;
  /* font-family: 'Helvetica, Arial, sans-serif' !important; */
    font-family: 'Helvetica' !important;
}
canvas {
  display: block;
  vertical-align: bottom;
}
.count-particles {
  background: #000022;
  position: absolute;
  top: 48px;
  left: 0;
  width: 80px;
  color: #13e8e9;
  font-size: 0.8em;
  text-align: left;
  text-indent: 4px;
  line-height: 14px;
  padding-bottom: 2px;
  font-family: Helvetica, Arial, sans-serif;
  font-weight: bold;
}
.js-count-particles {
  font-size: 1.1em;
}
#stats,
.count-particles {
  -webkit-user-select: none;
  margin-top: 5px;
  margin-left: 5px;
}
#stats {
  border-radius: 3px 3px 0 0;
  overflow: hidden;
}

.count-particles {
  border-radius: 0 0 3px 3px;
}
#particles {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #b61924;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 50% 50%;
}
</style>

<template>
  <div class="mainApp">
    <particles></particles>
    <router-view class="router-view"></router-view>
  </div>
</template>

<script>
import particles from 'components/dashboard/particles/particles'
import axios from "axios";
export default {
  data() {
    return {
      seller: {}
    };
  },
  components: {
    particles
  },
  created() {
  }
};
</script>



// WEBPACK FOOTER //
// App.vue?7a2e5f5d